export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/blue-info.6d686268.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};